module.exports = __webpack_public_path__ + "img/wechat.20f8da81.png";